import ContainerContent from "commons/container/ContainerContent";
import AccessDenied from "pages/accessDenied/AccessDenied";
import Account from "pages/account/Account";
import AlgoliaBanner from "pages/algoliaBanner/AlgoliaBanner";
import ProjectInfo from "pages/gant/components/ProjectInfo";
import ProjectContainer from "pages/gant/ProjectContainer";
import ProductInfo from "pages/inventory/components/ProductInfo";
import InventoryContainer from "pages/inventory/InventoryContainer";
import MessageInfo from "pages/messages/components/MessageInfo";
import MessagesContainer from "pages/messages/MessagesContainer";
import ParameterGestion from "pages/parameterGestion/ParameterGestion";
import Produits from "pages/produits/Produits";
import ReportFactory from "pages/report/ReportFactory";
import TreqReport from "pages/report/treqReport/TreqReport";
import PropTypes from "prop-types";
import React from "react";
import AlgoliaCategorie from "pages/algoliaCategorie/AlgoliaCategorie";
import Coop from "pages/report/coop/Coop";
import AchatsMedias from "pages/report/achatsMedias/AchatsMedias";
import Notifications from "pages/notifications/Notifications";
import ImagesHD from "../inventory/images/ImagesHD";

export default function FactoryComponent(props) {
  let component;
  switch (props.item.type) {
    case "gant":
      component = <ProjectContainer path={props.item.path} />;
      break;
    case "grid":
      component = (
        <ParameterGestion
          title={props.item.name}
          path={props.item.path}
          route={props.item.route}
          firstCol={props.item.key}
          creation={props.item.creation}
          modification={props.item.modification}
          canAdd={props.item.canAdd}
          id={props.item.id}
        />
      );
      break;
    case "project":
      component = <ProjectInfo />;
      break;
    case "ads":
      component = <MessagesContainer />;
      break;
    case "specificannonces":
      component = <MessageInfo />;
      break;
    case "account":
      component = <Account />;
      break;
    case "inventory":
      component = <InventoryContainer />;
      break;
    case "produit":
      component = <ProductInfo />;
      break;
    case "rapport":
      component = <ReportFactory report={props.item.report} />;
      break;
    case "treq":
      component = <TreqReport />;
      break;
    case "coop":
      component = <Coop />;
      break;
    case "achats":
      component = <AchatsMedias />;
      break;
    case "algoliaBanner":
      component = <AlgoliaBanner />;
      break;
    case "algoliaCategorie":
      component = <AlgoliaCategorie />;
      break;
    case "product":
      component = <Produits />;
      break;
    case "notifications":
      component = <Notifications />;
      break;
    case "imagesHd":
      component = <ImagesHD />;
      break;
    default:
      component = <AccessDenied />;
  }

  return <ContainerContent>{component}</ContainerContent>;
}

FactoryComponent.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    path: PropTypes.string,
    route: PropTypes.string,
    type: PropTypes.string,
    creation: PropTypes.string,
    modification: PropTypes.string,
    canAdd: PropTypes.bool,
    id: PropTypes.string,
    report: PropTypes.string,
  }),
};
